export interface CleanADirtyToteInput {
    containerId: string;
    warehouseId: string;
    associate: string;
    locale?: string;
}

export interface CleanADirtyToteOutput {
}

export const buildCleanADirtyToteInput = (containerId: string, warehouseId: string, associate: string, locale: string): CleanADirtyToteInput => {
    return {
        containerId,
        warehouseId,
        associate,
        locale
    }
}
